module.exports = __webpack_public_path__ + "img/Airbnb-Sensory-Overload-Protect-Eyes-and-ears.c510d68b.jpg";